import { render, staticRenderFns } from "./VmInventoryOff.vue?vue&type=template&id=0384e3db&scoped=true&"
import script from "./VmInventoryOff.vue?vue&type=script&lang=js&"
export * from "./VmInventoryOff.vue?vue&type=script&lang=js&"
import style0 from "./VmInventoryOff.vue?vue&type=style&index=0&id=0384e3db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0384e3db",
  null
  
)

export default component.exports